import { NeutralTypeEnum as r } from "../enum/neutral-type-enum.mjs";
const a = (e) => {
  switch (e) {
    case r.danger:
      return "hover:text-danger";
    case r.blue:
      return "hover:text-brand-primary";
    default:
      return "text-brand-primary";
  }
}, o = (e) => {
  switch (e) {
    case r.danger:
      return "hover:border-danger";
    case r.blue:
      return "hover:border-brand-primary";
    default:
      return "border-brand-primary";
  }
};
export {
  o as getHoverBorderColor,
  a as getHoverColor
};
